import React, {useState, useEffect, useRef, useLayoutEffect} from 'react'
import {
  Select,
  Input,
  Button,
  message,
  Tooltip,
  Modal,
  Popconfirm,
  Checkbox,
  DatePicker,
  InputNumber, Form, Radio, Card, Row, Col, Upload,

} from 'antd'
import { ajaxApi } from '@/server/index'
import { getParmUrl,tokenConfig,getCookieNew } from '@/public/utils'
import moment from 'moment'
import _lodash, { get,isNumber,set } from 'lodash'
import common from '@/public/common'
import styles from './index.module.less'
import {QuestionCircleOutlined, UploadOutlined} from '@ant-design/icons'
import {basicInformationRequiredverificationFun} from '../utils'
import {itemNamePlaceholderMap, itemNameTooltipMap, itemSeriesPlaceholderMap, itemSeriesTooltipMap} from './constant'
import {validValue} from '../../../public/utils'
import { initData } from '@/pages/commoditymanagement/addinfomation/utils'
import ExtendForm from './components/ExtendForm'
import LucencyForm from './components/LucencyForm.jsx'
const Option = Select.Option
const commonInputRule = [{required: true, message: '请输入'}]
const commonSelectRule = [{required: true, message: '请选择'}]
const BasicInformation = (props) => {
  const { getCurrent } = props
  const extendRef=useRef()
  const lastBrandInput = useRef()
  const [addData, setaddData] = useState(iniAddData)
  const [brandArr, setBrandArr] = useState([])
  const [searchBrandArr, setSearchBrandArr] = useState([])
  const [categoryArr, setCategoryArr] = useState([])
  const [venderList, setVenderList] = useState([])
  const [searchVenderArr, setSearchVenderArr] = useState([])
  const [placeOrigin, setplaceOrigin] = useState([])
  const [medicalName, setMedicalName] = useState([]) /// 医疗器械名称
  const [proModel, setProModel] = useState([]) /// 存储要求
  const [skuVisible, setskuVisible] = useState(false)
  const [skuVlue, setskuVlue] = useState('')
  const [skuType, setskuType] = useState('')
  const [skuIndex, setskuIndex] = useState(null)
  const [viewTypeValue, setViewTypeValue] = useState() // 判断界面类型
  const [categoryid, setCategoryid] = useState(getParmUrl('categoryid'))
  const [contactsTypeList, setContactsTypeList] = useState([]) // 类型
  // 品牌资质
  const isNeedToAddCredentials = useRef({result: true, message: ''}) // 是搜索到品牌资质
  const [addCredentialsVisible, setAddCredentialsVisible] = useState(false) // 添加品牌资质弹窗
  const [credentialsForm] = Form.useForm()
  const [chineseMainlandRegistFlag, setChineseMainlandRegistFlag] = useState(true) // 是否注册生产资质
  // 生产企业
  const [createCompanies, setCreateCompanies] = useState([])
  const [openBrandList, setOpenBrandList] = useState(false)
  const [addCreateCompaniesVisible, setCreateCompaniesVisible] = useState(false) // 添加生产企业弹窗
  const [createCompaniesFrom] = Form.useForm()

  useEffect(() => {
    setaddData({...iniAddData()})
  },[props.data])

  useEffect(() => {
    console.log(addData)
    setBrandArr(props.brandArr)
  },[props.brandArr])

  

  function iniAddData (initType) {
    const addData = initData()
    if (initType !== false) {
      lastBrandInput.current = _lodash.get(addData,'credentialData.type', 'add')
    }
    return addData
  }
  // 查询品牌
  const getQueryBrand = async () => {
      if (get(addData, 'item_info.brand_id')) {
        var searchBrandArr = brandArr.filter(item => {
          return item.id == get(addData, 'item_info.brand_id')
        })
        setSearchBrandArr(searchBrandArr)
      }
  }
  // 查询类别
  const getQueryCategory = async () => {
    try {
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-category',
        params: {}
      })
      if (res.status === 200 && res.data.data && res.data.data.length !== 0) {
        setCategoryArr(res.data.data)
      } else {
        setCategoryArr([])
      }
    } catch (e) {
    }
  }

  // 查询生产企业
  const getQueryCreateCompanies = () => {
    ajaxApi({
      url: common.scpUrl + 'item/query-create-companys'
      // url: 'http://192.168.10.67:8120/item/query-create-companys'
    }).then(res => {
      const { data } = res.data
      data.length > 0 && setCreateCompanies(data.map(el => ({
        ...el,
        label: el.create_company,
        value: el.create_company,
        tag: (
          <Tooltip title={el.create_company}>
            <span>{el.create_company.slice(0, 13) + '...'}</span>
          </Tooltip>
        )})))
    })
  }
  // 检验是否提供过品牌资质
  const validateBrandCredentials = (brandId, callBack) => {
    ajaxApi({
      url: common.scpUrl + 'item/check-brand-qualification',
      // url: 'http://192.168.10.67:8120/item/check-brand-qualification',
      params: {brand_id: brandId}
    }).then(res => {
      const { data } = res.data || {}
      const { check_result, check_message } = data
      if (check_result === 'fail') {
        isNeedToAddCredentials.current = {
          result: false,
          message: check_message
        }
      } else {
        isNeedToAddCredentials.current = {
          result: true,
          message: ''
        }
      }
      callBack && callBack()
    })
  }
  // 页面第一次加载并且有历史的输入商品品牌，判断是否录入品牌资质
  useEffect(() => {
    if (brandArr.length > 0) {
      const brandId = _lodash.get(addData, 'item_info.brand_id[0]')
      const result = brandArr.find(el => el.id == brandId || el.name == brandId)
      if (result) {
        validateBrandCredentials(result.id)
      } else {
        isNeedToAddCredentials.current = {
          result: false,
          message: '该品牌未录入过品牌资质，请先录入品牌资质'
        }
      }
    }
  },[brandArr])
  // 查询类型（按父类目编码查子类目，新接口 category/query-category-list）
  // value 取 category_code，label 取 category_name
  const queryContactsType = async () => {
    try {
      let res = await ajaxApi({
        url: common.mdmUrl + 'category/query-category-list',
        params: {
          parent_code: getParmUrl('categorycode') || null,
          is_leaf: true,
          operator_id: getCookieNew('accountId') || '10',
          operator_name: getCookieNew('supplier_company_name') || 'SCS系统'
        }
      })
      setContactsTypeList(get(res, 'data.data') || [])
    } catch (e) {
    }
  }

  // 查询存储要求
  const storagedataFun = async () => {
    try {
      let res = await ajaxApi({
        url: common.SapUrl + 'item/query-storage',
        params: {}
      })
      if (res.status === 200 && res.data.data && res.data.data.length !== 0) {
        setProModel(res.data.data)
      } else {
        setProModel([])
      }
    } catch (e) {
    }
  }
  // 原厂地
  const getPlaceOrigin = async () => {
    let res = await ajaxApi({
      url: common.scpUrl + 'item/query-origin-place',
      // url: 'http://192.168.10.220:8120/item/query-origin-place',
      params: {}
    })
    if (res.status && res.data) {
      setplaceOrigin(res.data.data || [])
    } else {
      setplaceOrigin([])
    }
  }
  // 获取医疗器械名称
  const getMedicalName = async () => {
    let res = await ajaxApi({
      // url:
      url: common.SapUrl + 'item/query-medical-name',
      params: {}
    })
    if (res.status && res.data) {
      setMedicalName(res.data.data || [])
    } else {
      setMedicalName([])
    }
  }

  // 获取 属性和sku
  const getQueryProperty = async () => {
    try {
      let _params = {
        category_id: addData.item_info.category_id
      }
      let res = await ajaxApi({
        url: common.scpUrl + 'item/query-property',
        // url: "http://192.168.10.220:8120/item/query-property",
        params: _params
      })
      if (res.status === 200 && res.data) {
        let _data = res.data.data
        if (_data.length !== 0&&addData.extend_propertys&&addData.sku_propertys) {
          if (
            addData.extend_propertys.length === 0 &&
              addData.sku_propertys.length === 0
          ) {
            _data = _lodash.reject(_data, ['property_name', 'ContactsType'])
            _lodash.forEach(_data, (item, index) => {
              if (item.property_type === 'Extend') {
                addData.extend_propertys.push({
                  property_id: item.property_id,
                  property_name: item.property_name,
                  sku_value: item.property_value ? item.property_value : [],
                  property_type: item.property_type,
                  is_required: item.is_required
                })
              } else {
                addData.sku_propertys.push({
                  property_id: item.property_id,
                  property_name: item.property_name,
                  sku_value: item.property_value || [],
                  property_type: item.property_type,
                  is_required: item.is_required
                })
              }
            })
          }
        }
        setaddData(addData)
        sessionStorage.setItem('addData', JSON.stringify(this.state.addData))
      }
    } catch (e) {
      // console.log(e)
    }
  }
  // 获取下拉框的值
  const handelChangeSource = (e, name) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.item_info[name] = e
    if (name === 'brand_id') {
      const brand = Array.isArray(e) ? e[e.length - 1] : e
      const selectItem = (brandArr || []).find(item => brand === item.id || brand === item.name)
      addDataClone.item_info.brand_id = selectItem ? [selectItem.id] : brand ? [brand] : void 0
      addDataClone.item_info.brand_name = selectItem ? selectItem.name : brand
      addDataClone.brand_qualification = {}
      lastBrandInput.current = selectItem ? 'updata' : 'add'
      addDataClone.credentialData = {
        type: lastBrandInput.current,
        validTime: [],
        files: []
      }
    }
    if (name === 'create_company') {
      addDataClone.item_info[name] = e // 生产企业单选
      addDataClone.create_company_bo = void 0
    }
    if (name == 'item_color_type') {
      var item_color_type_name = get(_lodash.filter(contactsTypeList, ['category_code', e]), '0.category_name')
      addDataClone.item_info['item_color_type_name'] = item_color_type_name
    }
    function isNumericOrDecimal(str) {
      const regex = /^-?\d+(\.\d+)?$/;
      return regex.test(str);
    }
    if (name == 'spec_unit'&&!isNumericOrDecimal(get(addDataClone,"item_info.spec"))) {
      addDataClone.item_info.spec = ""
    }
    console.log('save', addDataClone)
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 获取输入框的值
  const handleChangeInput = (e, name) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.item_info[name] = e.target.value
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  const iptNumChange = (value, key) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.item_info[key] = value
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 获取Extend输入框的值
  const handleChangeInputExtend = (e, index) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.extend_propertys[index].extend_value = e.target.value
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 获取Extend下拉框的值
  const handleChangeSelectExtend = (e, index) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.extend_propertys[index].extend_value = e
    console.log(addDataClone.extend_propertys[index], e)
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 隐形眼镜---扩展信息--输入框的值
  const handleChangeContactpropertyInput = (e, name) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (name === 'water') {
      const reg = /^-?[0-9]*(\.[0-9]*)?$/
      if ((!isNaN(e.target.value) && reg.test(e.target.value)) || e.target.value === '' || e.target.value === '-') {
        addDataClone.contact_property[name] = e.target.value
      }
    } else {
      addDataClone.contact_property[name] = e.target.value
    }
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }
  const inputWaterBlur = (e, type) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (type === 'water') {
      addDataClone.contact_property[type] = e.target.value ? parseFloat(e.target.value).toFixed(2) : e.target.value
      setaddData(addDataClone)
      sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    }
  }

  // 隐形眼镜---扩展信息--输入框的值
  const handelChangeContactpropertySource = (e, name) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.contact_property[name] = e
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 隐形眼镜---SKU--花色输入框的值
  const handleChangeColorpropertysInput = (e, name, index) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (addData.item_info.category_name === '透明彩色眼镜') {
      addDataClone.color_propertys[index][name] = '无色'
    } else {
      addDataClone.color_propertys[index][name] = e.target.value
    }
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }
  const handleChangeColorChange = (e, name, index) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.contact_property.thickness_list[index][name] = e.target.value
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }
  // 隐形眼镜---SKU--光度输入框的值
  const handleChangeLuminosityInput = (e, index, name) => {
    if (index !== null && name) {
      setskuType(name)
    }
    setskuVlue(e.target.value)
  }

  // 隐形眼镜---SKU--添加
  const handleColorAdd = (type) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (type === 'color') {
      addDataClone.color_propertys.push({
        'color': '',
        'base_arc': '',
        'dia': '',
        'color_dia': ''
      })
    } else if (type === 'thickness') {
      addDataClone.contact_property.thickness_list.push({
        'thickness_begin': '',
        'thickness_end': '',
        'thickness': ''
      })
    } else {
      if (!skuVlue) {
        message.warning('请填写光度', 2)
        return
      } else {
        if (skuVlue) {
          addDataClone.degrees.push(skuVlue)
        }
        addDataClone.degrees = _lodash.uniqWith(addDataClone.degrees, _lodash.isEqual)
        setskuVlue('')
      }
    }
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // sku添加
  const handleSkuAdd = (e, index, name) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (name === skuType) {
      if (skuVlue === '') {
        message.warning(`请先输入${name}再点添加！`)
      } else {
        addDataClone.sku_propertys[index].sku_value.push(skuVlue)
        addDataClone.sku_propertys[index].sku_value = _lodash.uniqWith(addDataClone.sku_propertys[index].sku_value, _lodash.isEqual)
        setskuVlue('')
      }
    } else {
      message.warning(`请先输入${name}再点添加！`)
    }

    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 隐形眼镜---sku--快捷添加
  const handleSeleteAdd = (e, index) => {
    if (index !== null) {
      setskuIndex(index)
    }
    setskuVisible(true)
  }

  // sku光度快捷添加
  const handleSkuQuickAdd = (e, type) => {
    const addDataClone = _lodash.cloneDeep(addData)
    let _skuArrMin = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00']
    let _skuArrMax = ['0.00', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00', '-8.50', '-9.00', '-9.50', '-10.00', '-10.50', '-11.00', '-11.50', '-12.00']
    if (skuIndex !== null) {
      if (type === 'Y-1.00-0.25-6.00-0.50-8.00') {
        _skuArrMin.map(item => {
          addData.sku_propertys[skuIndex].sku_value.push(item)
        })
      } else {
        _skuArrMax.map(item => {
          addData.sku_propertys[skuIndex].sku_value.push(item)
        })
      }
      addData.sku_propertys[skuIndex].sku_value = _lodash.uniqWith(addData.sku_propertys[skuIndex].sku_value, _lodash.isEqual)
    } else {
      if (type === 'Y-1.00-0.25-6.00-0.50-8.00') {
        _skuArrMin.map(item => {
          addDataClone.degrees.push(item)
        })
      } else {
        _skuArrMax.map(item => {
          addDataClone.degrees.push(item)
        })
      }
      addDataClone.degrees = _lodash.uniqWith(addDataClone.degrees, _lodash.isEqual)
    }
    setaddData(addDataClone)
    setskuVisible(false)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 隐形眼镜---SKU--删除
  const handleColorRemove = (index, type) => {
    const addDataClone = _lodash.cloneDeep(addData)
    if (type === 'color') {
      addDataClone.color_propertys.splice(index, 1)
    } else if (type === 'thickness') {
      addDataClone.contact_property.thickness_list.splice(index, 1)
    } else {
      addDataClone.degrees.splice(index, 1)
    }
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // sku删除
  const handledelete = (e, index, index2) => {
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.sku_propertys[index].sku_value.splice(index2, 1)
    setaddData(addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
  }

  // 下一步
  const handleNext = () => {
    let isRequire = basicInformationRequiredverificationFun(addData, getParmUrl('categoryid'))
    if (isRequire === undefined) {
      if (extendRef.current&&extendRef.current.formSebmit) {
        extendRef.current.formSebmit()
      }
      else {
        getCurrent(1)
      }
    }
  }
  // 取消
  const handleCancel = () => {
    setskuVisible(false)
  }

  useEffect(() => {
    if (!addData.item_info.origin_place) {
      const addDataClone = _lodash.cloneDeep(addData)
      addDataClone.item_info.origin_place = undefined
      setaddData(addDataClone)
      sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    }
    getQueryBrand()
    getQueryCreateCompanies()
    storagedataFun()
    getQueryCategory()
    // getVenderList()
    getPlaceOrigin()
    getMedicalName() // 获取医疗器械名称
    if (!getParmUrl('id')) {
      getQueryProperty()
    }
    setViewTypeValue(viewType())
    queryContactsType()
  }, [])
  // 判断是哪种类型的界面
  // 隐形眼镜一种   护理液/润眼液一种  其他的类别是一种
  const viewType = () => {
    const data = JSON.parse(sessionStorage.getItem('addData'))
    const specUnit = _lodash.get(data, 'item_info.spec_unit')
    const usefulUnit = _lodash.get(data, 'item_info.useful_unit')
    addData.item_info.is_gift = [0,1].includes(_lodash.get(data, 'item_info.is_gift'))?_lodash.get(data, 'item_info.is_gift'):0
    if (addData.item_info.category_id == '3') { // 隐形眼镜
      addData.item_info.spec_unit = specUnit || '片装'
      addData.item_info.useful_unit = usefulUnit || '年'
      return '1'
    } else if (addData.item_info.category_id == '5' || addData.item_info.category_id == '7') { // 护理液/润眼液
      addData.item_info.spec_unit = specUnit || 'ml'
      addData.item_info.useful_unit = usefulUnit || '年'
      return '2'
    } else { // 其他的类别
      addData.item_info.spec_unit = specUnit || '副'
      addData.item_info.useful_unit = usefulUnit || ''
      return '3'
    }
  }
  // 动态匹配品牌
  const handleSearch = (e, key) => {
    if (key == 'brand') {
      var searchBrandArr = []
      if (e) {
        searchBrandArr = brandArr.filter(item => {
          return item.name.indexOf(e) > -1
        })
      }
      setSearchBrandArr(searchBrandArr)
    }
    if (key == 'vender') {
      var searchVenderArr = []
      if (e) {
        searchVenderArr = venderList.filter(item => {
          return item.vender_name.indexOf(e) > -1
        })
      }
      setSearchVenderArr(searchVenderArr)
    }
  }

  const getRequiredIocn = () => {
    return <span className={styles.required}>*</span>
  }

  const upLoaderProps = {
    name: 'file',
    action: common.scpUrl + '/application/brand/uploadBrandQuaFile',
    accept: '.jpg,.jpeg,.png',
    headers:{...tokenConfig},
    beforeUpload (file) {
      if (file.type.includes('jpg') || file.type.includes('jpeg') || file.type.includes('png')) {
        return Promise.resolve(file)
      } else {
        message.warning('请上传支持格式的图片')
        return Promise.reject(file)
      }
    },
    onChange (info) {
      if (info.file.status === 'done') {
        // message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} 上传失败`)
      }
    }
  }
  // 判断当前输入的品牌是否为已有品牌
  const isExistingBrand = (id) => {
    return (brandArr || []).find(el => el.id === (id || _lodash.get(addData, 'item_info.brand_id[0]')))
  }

  const handelAddCredentialCancel = () => {
    setAddCredentialsVisible(false)
    credentialsForm.resetFields()
    setChineseMainlandRegistFlag(true)
  }
  // 添加品牌资质确认
  const handleAddCredentialOk = async () => {
    const credentialData = await credentialsForm.validateFields()
    const addDataClone = _lodash.cloneDeep(addData)
    const [begin_time, end_time] = credentialData.validTime || []
    let brandInfo
    if (_lodash.get(addData, 'item_info.brand_id') instanceof Array) {
      brandInfo = _lodash.get(addData, 'item_info.brand_id[0]') ? isExistingBrand() : {id: [_lodash.get(addData, 'item_info.brand_name')], name: _lodash.get(addData, 'item_info.brand_name')}
    } else {
      brandInfo = _lodash.get(addData, 'item_info.brand_id') ? isExistingBrand(_lodash.get(addData, 'item_info.brand_id')) : {id: [_lodash.get(addData, 'item_info.brand_name')], name: _lodash.get(addData, 'item_info.brand_name')}
    }
    addDataClone.brand_qualification = {
      ...credentialData,
      begin_time: begin_time ? moment(begin_time).valueOf() : void 0,
      end_time: end_time ? moment(end_time).valueOf() : void 0,
      files: _lodash.get(credentialData,'files', []).map(el => el.response.url),
      validTime: void 0,
      qua_name: '商标',
      brand_id: brandInfo ? brandInfo.id : null
    }
    addDataClone.credentialData = {...credentialData, type: lastBrandInput.current}
    addDataClone.item_info.brand_name = addDataClone.brand_qualification.brand_name
    addDataClone.item_info.brand_id = lastBrandInput.current === 'updata' ? [brandInfo.id] : [addDataClone.brand_qualification.brand_name]
    console.log('handleAddCredentialOk', addDataClone)
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    setaddData(addDataClone)
    handelAddCredentialCancel()
  }
  // 品牌输入blur事件
  const handleBrandIdSelect = () => {
    if (!isNeedToAddCredentials.current.result) {
      message.warning(isNeedToAddCredentials.current.message)
      lastBrandInput.current = 'updata'
      openAddCredential()
    }
  }
  function openAddCredential () {
    const _data = iniAddData(false)
    const flag = _lodash.get(_data,'credentialData.chinese_mainland_regist_flag')
    setChineseMainlandRegistFlag(_lodash.isNil(flag) ? true : (flag > 0))
    const validTime = _lodash.get(_data,'credentialData.validTime') || []
    const type = _lodash.get(_data,'credentialData.type')
    if (type === lastBrandInput.current) {
      credentialsForm.setFieldsValue({
        ..._data.credentialData,
        files: _lodash.get(_data,'credentialData.files',[]),
        validTime: validTime.length > 0 ? [moment(validTime[0]), moment(validTime[1])] : [],
        brand_name: _lodash.get(_data,'item_info.brand_name'),
        chinese_mainland_regist_flag: flag > -1 ? flag : 1,
      })
      if (lastBrandInput.current === 'add') {
        credentialsForm.setFieldsValue({
          brand_id: []
        })
      }
    } else {
      credentialsForm.resetFields()
      credentialsForm.setFieldsValue({
        chinese_mainland_regist_flag: 1,
        brand_name: _lodash.get(_data,'item_info.brand_name'),
      })
      setSearchBrandArr([])
      setChineseMainlandRegistFlag(true)
    }
    setTimeout(() => {
      setAddCredentialsVisible(true)
    },200)
  }

  // 生产企业 失焦事件
  const handleCreateCompanyBlur = () => {
    createCompaniesFrom.setFieldsValue({..._lodash.get(addData, 'create_company_bo', {})})
    setCreateCompaniesVisible(true)
  }

  const handleCreateCompanyCancel = () => {
    setCreateCompaniesVisible(false)
    createCompaniesFrom.resetFields()
  }

  // 生产企业确认录入
  const handleCreateCompanyOk = async () => {
    const createCompanyData = await createCompaniesFrom.validateFields()
    const addDataClone = _lodash.cloneDeep(addData)
    addDataClone.create_company_bo = createCompanyData
    set(addDataClone,'item_info.create_company',createCompanyData.create_company)
    setaddData({...addDataClone, item_info: { ...addData.item_info, create_company: createCompanyData.create_company }})
    sessionStorage.setItem('addData', JSON.stringify(addDataClone))
    handleCreateCompanyCancel()
  }
  const isCrossborder = _lodash.get(addData, 'item_info.is_cross_border', getParmUrl('iscrossborder')) == 1
  const categoryId = getParmUrl('categoryid')
  return (
    <div>
      <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
        <div style={{ width: '100%' }}>
          <div className={styles.total_title}>
            <span className={styles.titles}>基础信息</span>
          </div>
          <div className={styles.public_info}>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                {!['3', '5', '7', '21'].includes(categoryId) && <span className={styles.required}>*</span>}
                {itemNameTooltipMap.get(categoryId, isCrossborder) && <Tooltip title={itemNameTooltipMap.get(categoryId, isCrossborder)}>
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>}
                商品名称：
              </span>
              <Input
                value={addData ? addData.item_info.item_name : ''}
                placeholder={itemNamePlaceholderMap.get(categoryId, isCrossborder)}
                name="item_name"
                disabled={!!(['3', '5', '7', '21'].includes(categoryId))}
                onChange={(e) => handleChangeInput(e, 'item_name')}
                style={{ width: 244, marginRight: '0px' }}
              />
            </section>

            <section className={styles.publicsection} style={{width: '50%'}}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>
                <Tooltip title={'如果所录品牌之前未提供过商标资质，系统会弹屏要求必须录入'}>
                  <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                </Tooltip>
                商品品牌：
              </span>
              <Select
                open={openBrandList}
                showSearch
                allowClear
                mode={'tags'}
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请输入品牌名称'
                value={_lodash.isNil(_lodash.get(addData, 'item_info.brand_id')) ? void 0 : _lodash.get(addData, 'item_info.brand_id')}
                onChange={(e) => handelChangeSource(e, 'brand_id')}
                onSearch={(e) => {
                  setOpenBrandList(true)
                  handleSearch(e, 'brand')
                }}
                onFocus={() => {
                  setOpenBrandList(true)
                  handelChangeSource([], 'brand_id')
                }}
                onSelect={() => {
                  setOpenBrandList(false)
                  const _data = JSON.parse(sessionStorage.getItem('addData'))
                  console.log('select',_data)
                }}
                onBlur={() => {
                  setOpenBrandList(false)
                  const _data = JSON.parse(sessionStorage.getItem('addData'))
                  console.log('blur',_data)
                  if (!_lodash.get(_data, 'item_info.brand_name')) return
                  if (_lodash.get(_data,'credentialData.type') === 'add') {
                    openAddCredential()
                  } else {
                    validateBrandCredentials(_lodash.get(_data,'item_info.brand_id[0]'), () => {
                      handleBrandIdSelect()
                    })
                  }
                }}
                tagRender={({label, value}) => {
                  const target = brandArr.find(el => el.id === value) || {}
                  return <span style={{paddingLeft: 8}}>{target.name || label}</span>
                }}
              >
                {searchBrandArr.length !== 0 ? searchBrandArr.map((item, index) => (
                  <Option key={index + 1} name='brand_id' value={item.id}>{item.name}</Option>
                )) : null}
              </Select>
              <span
                hidden={!validValue(addData, 'brand_qualification')}
                style={{color: '#1890ff', marginLeft: 8, cursor: 'pointer'}}
                onClick={() => {
                  openAddCredential()
                }}>
                查看资质
              </span>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>{ ['3','5','7','21'].includes(categoryid)&&'*'}</span>
                <Tooltip title={itemSeriesTooltipMap.get(categoryId, isCrossborder)}><QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/></Tooltip>
                商品系列：
              </span>
              <Input
                value={addData ? addData.item_info.item_series : ''}
                placeholder={itemSeriesPlaceholderMap.get(categoryId, isCrossborder)}
                name="item_series"
                allowClear
                onChange={(e) => handleChangeInput(e, 'item_series')}
                style={{ width: 244, marginRight: '0px' }}
              />
              {
                ['3', '5', '7', '21'].includes(categoryId) &&
                <span style={{marginLeft: '8px'}}>系列</span>
              }
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>类型：
              </span>
              <Select
                showSearch
                allowClear
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData && addData.item_info.item_color_type ? addData.item_info.item_color_type : undefined}
                onChange={(e) => handelChangeSource(e, 'item_color_type')}
              >
                {
                  contactsTypeList.map(item => {
                    return (
                      <Option
                        key={get(item, 'category_code')}
                        name='item_color_type'
                        value={get(item, 'category_code')}
                      >
                        {get(item, 'category_name')}
                      </Option>
                    )
                  })
                }

              </Select>
            </section>

            <section className={styles.publicsection} style={{display: 'none'}}>
              <span className={styles.publlictitle}>
                商品类别：
              </span>
              <Select
                showSearch
                // mode="multiple"
                allowClear
                disabled
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData ? addData.item_info.category_id : ''}
                onChange={(e) => handelChangeSource(e, 'category_id')}
              >
                <Option key={0} name='category_id' value=''>请选择</Option>
                {categoryArr.length !== 0 ? categoryArr.map((item, index) => (
                  <Option key={index + 1} name='category_id' value={item.id}>{item.name}</Option>
                )) : null}
              </Select>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>规格：
              </span>
              {
                get(addData, "item_info.spec_unit") ? (
                  <InputNumber
                    allowClear
                    placeholder="请输入"
                    name="spec"
                    value={addData ? addData.item_info.spec : ''}
                    onChange={(e) => handleChangeInput({target:{value:e}}, 'spec')}
                    style={{ width: 244 }} />
                )
                  : (
                    <Input
                      allowClear
                      placeholder="请输入"
                      name="spec"
                      value={addData ? addData.item_info.spec : ''}
                      onChange={(e) => handleChangeInput(e, 'spec')}
                      style={{ width: 244 }}
                    />
                  )
              }
              <Select
                showSearch
                // mode="multiple"
                allowClear
                style={{ width: 90, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData && addData.item_info.spec_unit ? addData.item_info.spec_unit : undefined}
                onChange={(e) => {handelChangeSource(e, 'spec_unit')}}
              >
                <Option key={'片装'} name='spec_unit' value='片装'>片装</Option>
                <Option key={'ml'} name='spec_unit' value='ml'>ml</Option>
                <Option key={'副'} name='spec_unit' value='副'>副</Option>
              </Select>
              <br/>
              {
                !get(addData, "item_info.spec_unit") && (<span style={{ marginLeft: '150px' }}>（请注意填写示例：x片装、x ml、x副）</span>)
              }
            </section>

            <section className={styles.publicsection} style={{display: getParmUrl('categoryid') === '3' ? 'block' : 'none'}}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>商品材质：
              </span>
              <Select
                showSearch
                // mode="multiple"
                allowClear
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData && addData.item_info.item_material ? addData.item_info.item_material : undefined}
                onChange={(e) => handelChangeSource(e, 'item_material')}
              >
                {/* <Option key={'PC硅水凝胶'} name='item_material' value='PC硅水凝胶'>PC硅水凝胶</Option> */}
                <Option key={'水凝胶'} name='item_material' value='水凝胶'>水凝胶</Option>
                <Option key={'硅水凝胶'} name='item_material' value='硅水凝胶'>硅水凝胶</Option>
              </Select>
            </section>

            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>产品有效期：
              </span>
              <Input
                allowClear
                disabled={addData ? addData.item_info.is_long_expiration : false}
                // onkeyup="value=value.replace(/[^0-9]/g,'')"
                // onpaste="value=value.replace(/[^0-9]/g,'')"
                // oncontextmenu="value=value.replace(/[^0-9]/g,'')"
                placeholder="请输入"
                value={addData ? addData.item_info.item_useful_life : ''}
                name="item_useful_life"
                onChange={(e) =>
                  handleChangeInput(e, 'item_useful_life')
                }
                style={{ width: 146, marginRight: '4px' }}
              />
              <Select
                showSearch
                // mode="multiple"
                allowClear
                disabled={addData ? addData.item_info.is_long_expiration : false}
                style={{ width: 90, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={_lodash.get(addData, 'item_info.useful_unit') ? addData.item_info.useful_unit : undefined}
                onChange={(e) => handelChangeSource(e, 'useful_unit')}
              >
                <Option key={1} name='useful_unit' value='年'>年</Option>
                <Option key={2} name='useful_unit' value='月'>月</Option>
                <Option key={3} name='useful_unit' value='日'>日</Option>
              </Select>
              {
                (
                  // ['3','5', '7', '21'].includes(getParmUrl('categoryid')) ||
                  ['10', '11', '12', '16', '17', '20', '31'].includes(getParmUrl('categoryid')) && addData.item_info.is_cross_border == 1
                )
                  ? null
                  : <Checkbox
                    style={{ marginLeft: '4px' }}
                    checked={addData ? addData.item_info.is_long_expiration : false}
                    onChange={(e) => handelChangeSource(e.target.checked, 'is_long_expiration')}
                  >长期有效</Checkbox>
              }
            </section>

            {viewTypeValue === '1' ? <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>是否散光片：
              </span>
              <Select
                showSearch
                // mode="multiple"
                allowClear
                style={{ width: 244, marginRight: '0px' }}
                optionFilterProp="children"
                placeholder='请选择'
                value={addData && (addData.item_info.is_customed || addData.item_info.is_customed === 0) ? addData.item_info.is_customed : undefined}
                onChange={(e) => handelChangeSource(e, 'is_customed')}
              >
                <Option key={1} name='is_customed' value={1}>是</Option>
                <Option key={2} name='is_customed' value={0}>否</Option>
              </Select>
            </section> : ''}
            {/* 是否进口需确认接口字段 */}
            {
              ['3', '5', '7'].includes(getParmUrl('categoryid')) &&
              getParmUrl('iscrossborder') == 0 &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>是否进口：
                </span>
                <Select
                  showSearch
                  // mode="multiple"
                  allowClear
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && (addData.item_info.is_import || addData.item_info.is_import === 0) ? addData.item_info.is_import : undefined}
                  onChange={(e) => handelChangeSource(e, 'is_import')}
                >
                  <Option key={1} name='is_import' value={1}>是</Option>
                  <Option key={0} name='is_import' value={0}>否</Option>
                </Select>
              </section>
            }
            {
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  是否赠品：
                </span>
                <Select
                  allowClear
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && (addData.item_info.is_gift || addData.item_info.is_gift === 0) ? addData.item_info.is_gift : undefined}
                  onChange={(e) => handelChangeSource(e, 'is_gift')}
                >
                  <Option key={1} name='is_gift' value={1}>是</Option>
                  <Option key={0} name='is_gift' value={0}>否</Option>
                </Select>
              </section>
            }
            {
              (['3', '5', '7'].includes(getParmUrl('categoryid')) &&
              getParmUrl('iscrossborder') == 0)
                ? <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>
                  产地：
                  </span>
                  <Select
                    showSearch
                    // mode="multiple"
                    allowClear
                    style={{ width: 244, marginRight: '0px' }}
                    optionFilterProp="children"
                    placeholder='请选择'
                    value={addData && addData.item_info.origin_place ? addData.item_info.origin_place : undefined}
                    onChange={(e) => handelChangeSource(e, 'origin_place')}
                  >
                    {placeOrigin.length !== 0 ? placeOrigin.map((item, index) => (
                      <Option key={index + 1} name='origin_place' value={item.name}>{item.name}</Option>
                    )) : null}
                  </Select>
                </section> : ''
            }
            {
              (viewTypeValue === '1' || viewTypeValue === '2') && getParmUrl('iscrossborder') == 0 ? <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  <Tooltip title={'委托生产是指：不是“注册人/备案人”自己生产，委托别的工厂生产的；自行生产是指：注册人/备案人”自己生产'}>
                    <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                  </Tooltip>
                  生产方式：
                </span>
                <Select
                  showSearch
                  // mode="multiple"
                  allowClear
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && (addData.item_info.produce_type || addData.item_info.produce_type === 0) ? addData.item_info.produce_type : undefined}
                  onChange={(e) => handelChangeSource(e, 'produce_type')}
                >
                  <Option key={1} name='produce_type' value={'selfproduction'}>自行生产</Option>
                  <Option key={0} name='produce_type' value={'commissionedproduction'}>委托生产</Option>
                </Select>
              </section> : ''
            }
            {
              !isCrossborder &&
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  生产企业：
                </span>
                <Select
                  style={{ width: 244, marginRight: '0px' }}
                  options={createCompanies}
                  showSearch
                  allowClear
                  placeholder='请选择'
                  optionFilterProp={'label'}
                  maxTagTextLength={13}
                  value={_lodash.get(addData, 'item_info.create_company') || void 0}
                  onChange={(e) => handelChangeSource(e, 'create_company')}
                />
                <br/>
                <span
                  style={{color: 'red', marginLeft: 8, cursor: 'pointer', marginLeft:'160px'}}
                  onClick={() => {
                    handleCreateCompanyBlur()
                  }}>如下拉框无值，点此录入</span>
              </section>
            }
            {
              (viewTypeValue === '1' || viewTypeValue === '2') && getParmUrl('iscrossborder') == 0 ? <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  <Tooltip title={'指医疗器械注册证中的“产品名称'}>
                    <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                  </Tooltip>
                  医疗器械名称：
                </span>
                <Select
                  showSearch
                  // mode="multiple"
                  allowClear
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && (addData.item_info.medical_name || addData.item_info.medical_name === 0) ? addData.item_info.medical_name : undefined}
                  onChange={(e) => handelChangeSource(e, 'medical_name')}
                >
                  {medicalName.length !== 0 ? medicalName.map((item, index) => (
                    <Option key={index + 1} name='medical_name' value={item.name}>{item.name}</Option>
                  )) : null}
                </Select>
              </section> : ''
            }
            {/* 主要功能需确认接口字段 */}
            {
              (viewTypeValue === '1' || viewTypeValue === '2') && getParmUrl('iscrossborder') == 0 ? <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  主要功能：
                </span>
                <Input
                  value={addData ? addData.item_info.main_function : ''}
                  placeholder={'请输入适用范围'}
                  name="main_function"
                  onChange={(e) => handleChangeInput(e, 'main_function')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section> : ''
            }
            {/* 存储要求需确认接口字段 */}
            {
              (viewTypeValue === '1' || viewTypeValue === '2') && getParmUrl('iscrossborder') == 0 ? <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  存储要求：
                </span>
                <Select
                  showSearch
                  mode="multiple"
                  allowClear
                  style={{ width: 244, marginRight: '0px' }}
                  optionFilterProp="children"
                  placeholder='请选择'
                  value={addData && addData.item_info.storages ? addData.item_info.storages : []}
                  onChange={(e) => handelChangeSource(e, 'storages')}
                >
                  {proModel ? proModel.map((item, index) => (<Option key={index + 'b'} value={item.name}>{item.name}</Option>)) : null}

                </Select>
              </section> : ''
            }
            {/* 型号及规格需确认接口字段 */}
            {
              (viewTypeValue === '1' || viewTypeValue === '2') && getParmUrl('iscrossborder') == 0 ? <section className={styles.publicsection}>
                <span className={styles.publlictitle}>
                  <span className={styles.required}>*</span>
                  <Tooltip title={'指医疗器械注册证中的“型号、规格'}>
                    <QuestionCircleOutlined style={{color: 'gray', margin: '0px 2px'}}/>
                  </Tooltip>
                  型号及规格：
                </span>
                <Input
                  value={addData ? addData.item_info.pro_model : ''}
                  placeholder={'请输入'}
                  name="pro_model"
                  onChange={(e) => handleChangeInput(e, 'pro_model')}
                  style={{ width: 244, marginRight: '0px' }}
                />
              </section> : ''
            }
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>单品重量：
              </span>
              <InputNumber
                min={0}
                max={9999}
                value={get(addData, 'item_info.weight') ? Number(get(addData, 'item_info.weight')) : null}
                onChange={(e) => {
                  iptNumChange(e, 'weight')
                  if (e !== null && e !== undefined && String(e).includes('.')) {
                    const decimalPart = String(e).split('.')[1]
                    if (decimalPart && decimalPart.length > 2) {
                      message.warning('单品重量最多支持两位小数', 2)
                    }
                  }
                }}
                style={{ width: 144, marginRight: '0px' }}
              />
              <span>（kg）</span>
            </section>
            <section className={styles.publicsection}>
              <span className={styles.publlictitle}>
                <span className={styles.required}>*</span>箱规：
              </span>
              <InputNumber
                min={0}
                max={9999}
                precision={0}
                value={get(addData, 'item_info.packing_specification') ? Number(get(addData, 'item_info.packing_specification')) : null}
                onChange={(e) => { iptNumChange(e, 'packing_specification') }}
                style={{ width: 244, marginRight: '0px' }}
              />
              <span>个/箱</span>
            </section>
            {
                addData && addData.item_info.category_id == 3 &&
                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>更换周期：
                  </span>
                  <Select
                    showSearch
                    // mode="multiple"
                    allowClear
                    style={{ width: 244, marginRight: '0px' }}
                    optionFilterProp="children"
                    placeholder='请选择'
                    value={addData && addData.contact_property.change_cycle ? addData.contact_property.change_cycle : undefined}
                    onChange={(e) => handelChangeContactpropertySource(e, 'change_cycle')}
                  >
                    <Option key={1} name='change_cycle' value='Day'>日抛</Option>
                    <Option key={2} name='change_cycle' value='Week'>周抛</Option>
                    <Option key={3} name='change_cycle' value='Fortnight'>双周抛</Option>
                    <Option key={4} name='change_cycle' value='Month'>月抛</Option>
                    <Option key={5} name='change_cycle' value='TwoMonths'>双月抛</Option>
                    <Option key={6} name='change_cycle' value='Quarter'>季抛</Option>
                    <Option key={7} name='change_cycle' value='SixMonths'>半年抛</Option>
                    <Option key={8} name='change_cycle' value='Year'>年抛</Option>
                  </Select>
                </section>
              }
          </div>

          {addData && addData.item_info.is_cross_border === 1
            ? <span>
              <div className={styles.total_title}>
                <span className={styles.titles}>海淘信息</span>
              </div>

              <div className={styles.public_info}>
                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>商品英文名称：
                  </span>
                  <Input
                    allowClear
                    value={ addData ? addData.item_info.english_name : '' }
                    placeholder="请输入"
                    name="english_name"
                    onChange={(e) => handleChangeInput(e, 'english_name')}
                    style={{ width: 244, marginRight: '0px' }}
                  />
                </section>
                <section className={styles.publicsection} style={{width: '50%'}}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>生产企业：
                  </span>
                  <Select
                    style={{ width: 244, marginRight: '0px' }}
                    options={createCompanies}
                    optionFilterProp={'label'}
                    showSearch
                    allowClear
                    placeholder="请选择"
                    maxTagTextLength={13}
                    value={_lodash.get(addData, 'item_info.create_company') || void 0}
                    onChange={(e) => handelChangeSource(e, 'create_company')}
                  />
                  <span
                    style={{color: 'red', marginLeft: 8, cursor: 'pointer'}}
                    onClick={() => {
                      handleCreateCompanyBlur()
                    }}>如下拉框无值，点此录入</span>
                </section>

                <section className={styles.publicsection}>
                  <span className={styles.publlictitle}>
                    <span className={styles.required}>*</span>产地：
                  </span>
                  <Select
                    showSearch
                    // mode="multiple"
                    allowClear
                    style={{ width: 244, marginRight: '0px' }}
                    optionFilterProp="children"
                    placeholder='请选择'
                    value={addData && addData.item_info.origin_place ? addData.item_info.origin_place : undefined}
                    onChange={(e) => handelChangeSource(e, 'origin_place')}
                  >
                    {placeOrigin.length !== 0 ? placeOrigin.map((item, index) => (
                      <Option key={index + 1} name='origin_place' value={item.name}>{item.name}</Option>
                    )) : null}
                  </Select>
                </section>
              </div>
            </span>
            : null}

          {addData && addData.item_info.category_id == 3
            ? <div>
                 {  get(addData, 'item_info.item_color_type_name') &&
                  get(addData, 'item_info.item_color_type_name').includes('彩色') ?
              <div>
                  <div className={styles.total_title}>
                 <span className={styles.titles}>SKU</span>
                </div>
                <div style={{marginBottom:'10px',paddingLeft:'17%'}}  className={styles.public_info} >
                  <section className={styles.publicsection} style={{width:'100%'}}>
                    <span className={styles.publlictitle} style={{width:'100px'}}>
                      {getRequiredIocn()}光度111：
                    </span>
                    <Input
                      placeholder="请输入"
                      name="color_dia"
                      value={skuVlue}
                      allowClear
                      onChange={(e) => handleChangeLuminosityInput(e)}
                      style={{ width: 244, marginRight: '8px' }}
                    />
                    <a style={{margin: '0px 4px'}} onClick={() => handleColorAdd('luminosity') }>手动添加</a>
                    <a onClick={(e) => handleSeleteAdd(e, null)}>选择添加</a>
                    <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: '96px'}}>
                      {addData && addData.degrees.length !== 0 ? (
                        addData.degrees.map((item, index) => {
                          return (
                            <span key={index}>
                              <Popconfirm title="确定要删除吗？" onConfirm={() => handleColorRemove(index, 'luminosity')} okText="确定" cancelText="取消" trigger={'hover'}>
                                <a style={{marginRight: '8px'}}>{item}</a>
                              </Popconfirm>
                            </span>
                        )
                      })
                    ) : null}
                  </div>
                </section>
                  </div>
                  <ExtendForm addData={addData} changeData={setaddData} getCurrent={getCurrent} ref={extendRef} />
                </div> :
                <div>
                  <LucencyForm addData={addData} changeData={setaddData} getCurrent={getCurrent} ref={extendRef} />
                  <div className={styles.total_title}>
                 <span className={styles.titles}>SKU</span>
                  </div>
           <div className={styles.public_info}> 
              <section className={styles.publicsection} style={{ width: '70%' }}>
                <span className={styles.publlictitle}>
                  {getRequiredIocn()}光度：
                </span>
                <Input
                  placeholder="请输入"
                  name="color_dia"
                  value={skuVlue}
                  allowClear
                  onChange={(e) => handleChangeLuminosityInput(e)}
                  style={{ width: 244, marginRight: '8px' }}
                />
                <a style={{margin: '0px 4px'}} onClick={() => handleColorAdd('luminosity') }>手动添加</a>
                <a onClick={(e) => handleSeleteAdd(e, null)}>选择添加</a>
                <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 162}}>
                  {addData && addData.degrees.length !== 0 ? (
                    addData.degrees.map((item, index) => {
                      return (
                        <span key={index}>
                          <Popconfirm title="确定要删除吗？" onConfirm={() => handleColorRemove(index, 'luminosity')} okText="确定" cancelText="取消" trigger={'hover'}>
                            <a style={{marginRight: '8px'}}>{item}</a>
                          </Popconfirm>
                        </span>
                    )
                  })
                ) : null}
              </div>
             </section>   </div>
            </div> 
                }
            </div>
            : (
              <span>
                <div className={styles.total_title}
                  style={{ display: addData && get(addData,'extend_propertys.length') !== 0 ? 'block' : 'none'}} >
                  <span className={styles.titles}>扩展信息</span>
                </div>
                <div className={styles.public_info}>
                  {addData &&get(addData,'extend_propertys.length') !== 0
                    ? get(addData,'extend_propertys',[]).map((item, index) => {
                      if (item.property_type === 'Extend') {
                        // ContactsType 都不展示
                        if (item.property_name === 'ContactsType') return null
                        return (
                          <section className={styles.publicsection} key={index}>
                            <span className={styles.publlictitle}>
                              <span
                                className={styles.required}
                                style={{
                                  display:
                                    item.is_required === 1
                                      ? 'inline-block'
                                      : 'none'
                                }}
                              >
                                *
                              </span>
                              {item.property_name}：
                            </span>
                            {item.property_name === '更换周期' ? (
                              <Select
                                showSearch
                                // mode="multiple"

                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                allowClear
                                value={item.extend_value || undefined}
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={1} value='日抛'>日抛</Option>
                                <Option key={2} value='周抛'>周抛</Option>
                                <Option key={3} value='月抛'>月抛</Option>
                                <Option key={4} value='半年抛'>半年抛</Option>
                                <Option key={4} value='年抛'>年抛</Option>
                              </Select>
                            ) : item.property_name === '是否高散光高度数' ? (

                              <Select
                                showSearch
                                // mode="multiple"

                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                allowClear
                                value={item.extend_value || item.extend_value === 0 ? item.extend_value : undefined}
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={1} value={1}>是</Option>
                                <Option key={2} value={0}>否</Option>

                              </Select>
                            ) : item.property_name === 'ContactsType' ? (
                              <Select
                                showSearch
                                // mode="multiple"
                                allowClear
                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                value={item.extend_value || undefined}
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={0} value='普通隐形眼镜'>普通隐形眼镜</Option>
                                <Option key={1} value='彩色隐形眼镜'>彩色隐形眼镜</Option>
                              </Select>
                            ) : item.property_name === '是否支持渐近多焦' ? (
                              <Select
                                showSearch
                                // mode="multiple"

                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                value={item.extend_value || item.extend_value === 0 ? item.extend_value : undefined}
                                allowClear
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={1} value={1}>是</Option>
                                <Option key={2} value={0}>否</Option>
                              </Select>
                            ) : item.property_name === '材质是否支持记忆功能' ? (
                              <Select
                                showSearch
                                // mode="multiple"

                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                value={item.extend_value || item.extend_value === 0 ? item.extend_value : undefined}
                                allowClear
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={1} value={1}>是</Option>
                                <Option key={2} value={0}>否</Option>
                              </Select>
                            ) : item.property_name === '抗UV' ? (
                              <Select
                                showSearch
                                // mode="multiple"

                                style={{ width: 244, marginRight: '0px' }}
                                optionFilterProp="children"
                                placeholder='请选择'
                                value={item.extend_value || item.extend_value === 0 ? item.extend_value : undefined}
                                allowClear
                                onChange={(e) => handleChangeSelectExtend(e, index)}
                              >
                                <Option key={1} value={1}>是</Option>
                                <Option key={2} value={0}>否</Option>
                              </Select>
                            )
                              : (<Input
                                // onKeyDown={this.onKeyup}
                                // onKeyDown={this.onKeyup}
                                placeholder="请输入"
                                value={item.extend_value}
                                allowClear
                                onChange={(e) => handleChangeInputExtend(e, index)}
                                style={{ width: 244, marginRight: '0px' }}
                              />)}

                          </section>
                        )
                      }
                    })
                    : null}
                </div>

                <div className={styles.total_title}
                  style={{ display:addData &&  addData.sku_propertys && addData.sku_propertys.length !== 0 ? 'block' : 'none'}}>
                  <span className={styles.titles}>SKU</span>
                </div>

                <div className={styles.public_info}>
                  {addData && addData.sku_propertys && addData.sku_propertys.length !== 0
                    ? addData.sku_propertys.map((item, index) => {
                      if (item.property_type === 'SKU') {
                        if (item.property_name !== '光度') {
                          return (
                            <section key ={index} className={styles.publicsection}>
                              <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                              <Input
                                placeholder="请输入"
                                allowClear
                                value={skuType === item.property_name ? skuVlue : ''}
                                onChange={(e) => handleChangeLuminosityInput(e, index, item.property_name)}
                                style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                              <a style={{marginLeft: 4}} onClick={(e) => handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                              <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 136}}>
                                {item.sku_value ? (
                                  item.sku_value.length !== 0 ? (
                                    item.sku_value.map((item2, index2) => {
                                      return (
                                        <span key={index2}>
                                          <Popconfirm title="确定要删除吗？" onConfirm={(e) => handledelete(e, index, index2)} okText="确定" cancelText="取消" trigger={'hover'}>
                                            <a style={{marginRight: '8px'}}>{item2}</a>
                                          </Popconfirm>
                                        </span>

                                      )
                                    })
                                  ) : null
                                ) : null}
                              </div>
                            </section>
                          )
                        } else {
                          return (
                            <section key ={index} className={styles.publicsection}>
                              <span className={styles.publlictitle}><span className={styles.required} style={{display: item.is_required === 1 ? 'inline-block' : 'none'}}>*</span>{item.property_name}：</span>
                              <Input
                                placeholder="请输入"
                                allowClear
                                value={skuType === item.property_name ? skuVlue : ''}
                                onChange={(e) => handleChangeLuminosityInput(e, index, item.property_name)}
                                style={{ width: 244, marginRight: '0px', marginBottom: '12px' }}/>
                              <a style={{marginLeft: 4}} onClick={(e) => handleSkuAdd(e, index, item.property_name)}>手动添加</a>
                              <a style={{marginLeft: 4}} onClick={(e) => handleSeleteAdd(e, index)}>选择添加</a>
                              <div style={{display: 'flex', width: '250px', flexWrap: 'wrap', marginLeft: 162}}>
                                {item.sku_value ? (
                                  item.sku_value.length !== 0 ? (
                                    item.sku_value.map((item2, index2) => {
                                      return (
                                        <span key={index2}>
                                          <Popconfirm title="确定要删除吗？" onConfirm={(e) => handledelete(e, index, index2)} okText="确定" cancelText="取消" trigger={'hover'}>
                                            <a style={{marginRight: '8px'}}>{item2}</a>
                                          </Popconfirm>

                                        </span>
                                      )
                                    })
                                  ) : null
                                ) : null}
                              </div>
                            </section>
                          )
                        }
                      }
                    })
                    : null}
                </div>
              </span>
            )}
          <div
            style={{
              width: '100%',
              marginBottom: '24px',
              marginTop: '56px',
              textAlign: 'center'
            }}
          >
            <Button
              type=""
              style={{ margin: '0px 8px' }}
              onClick={handleNext}
              shape="round"
            >
            下一步
            </Button>
          </div>

          <Modal
            title='选择要添加的SKU属性值'
            open={skuVisible}
            width={700}
            onCancel={handleCancel}
            footer={false}
          >
            <div style={{color: '#00f'}}>光度值规则：是否平光(Y/N)-起始度数(1.00)-起跳幅度(0.25)-结束度数(3.00)-二次起幅度(0.50)-二次起跳结束度数(5.00) ...</div>
            <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around', margin: '24px 0px'}}>
              <span onClick={(e) => handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-8.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-8.00</span>
              <span onClick={(e) => handleSkuQuickAdd(e, 'Y-1.00-0.25-6.00-0.50-12.00')} className={styles.skustyle}>Y-1.00-0.25-6.00-0.50-12.00</span>
            </div>
            <div style={{textAlign: 'center'}}>1/1页(共2条记录/每页显示15条)</div>
          </Modal>

          <Modal
            title='录入品牌资质'
            visible={addCredentialsVisible}
            width={1000}
            onCancel={() => {
              handelAddCredentialCancel()
              // credentialsForm.getFieldsValue('chinese_mainland_regist_flag,)
              // credentialsForm.getFieldsValue('chinese_mainland_regist_flag')
              if (!_lodash.get(addData, 'credentialData.brand_name')) {
                handelChangeSource(void 0, 'brand_id')
              }
            }}
            onOk={handleAddCredentialOk}
            forceRender
            destroyOnClose
          >
            <Form form={credentialsForm} labelCol={{ span: 5 }}>
              <div style={{flex: 1}}>
                <Row style={{marginBottom: 24}}>
                  <Col span={8}>
                    <Form.Item label='品牌' name='brand_name' labelCol={{offset: 6}} rules={!isNeedToAddCredentials.current.result && !isExistingBrand() && commonInputRule}>
                      <Input placeholder='请输入品牌名称'
                        disabled={lastBrandInput.current === 'updata'}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={16}>
                    <Form.Item label='中国大陆是否注册商标' name='chinese_mainland_regist_flag' labelCol={{span: 8, offset: 2}} rules={commonSelectRule} >
                      <Radio.Group
                        onChange={(e) => {
                          setChineseMainlandRegistFlag(e.target.value === 1)
                          e.target.value === 0 && credentialsForm.validateFields()
                        }}
                      >
                        <Radio value={1}>是</Radio>
                        <Radio value={0}>否</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
                <Card>
                  <Row style={{marginBottom: 24}} gutter={24}>
                    <Col span={12}>
                      <Form.Item label='资质名称' required={chineseMainlandRegistFlag}>
                        <span style={{color: 'orange'}}>商标</span>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label='有效日期' name='validTime' rules={chineseMainlandRegistFlag && commonSelectRule}>
                        <DatePicker.RangePicker style={{width: '100%'}}></DatePicker.RangePicker>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row style={{marginBottom: 24}} gutter={24}>
                    <Col span={12}>
                      <Form.Item label='商标类别' name='brand_type' rules={chineseMainlandRegistFlag && commonSelectRule}>
                        <Select placeholder='请选择'>
                          <Option value="3类-洗眼液">3类-洗眼液</Option>
                          <Option value="5类-护理液润眼液">5类-护理液润眼液</Option>
                          <Option value="9类-隐形眼镜">9类-隐形眼镜</Option>
                          <Option value="25类-眼罩">25类-眼罩</Option>
                          <Option value="35类-广告宣传">35类-广告宣传</Option>
                          <Option value="其他">其他</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label='商标注册人' name='brand_register' rules={chineseMainlandRegistFlag && commonInputRule}>
                        <Input placeholder='请输入与商标注册证一致的名称'></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item label='资质证号' name='qua_code' rules={chineseMainlandRegistFlag && commonInputRule}>
                        <Input placeholder='请输入' />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label='资质附件'
                        name='files'
                        rules={chineseMainlandRegistFlag && [{required: true, message: '请上传文件'}]}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => Array.isArray(e) ? e : e.fileList}
                      >
                        <Upload {...upLoaderProps}>
                          <Button icon={<UploadOutlined />}>上传文件</Button>
                          <span style={{marginLeft: 8, color: 'rgba(0,0,0,0.45)'}}>支持扩展名: .jpg、.jpeg、.png</span>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>
                </Card>
              </div>
            </Form>
          </Modal>
          <Modal
            title='录入生产企业'
            visible={addCreateCompaniesVisible}
            width={700}
            onCancel={() => {
              handleCreateCompanyCancel()
            }}
            onOk={handleCreateCompanyOk}
            forceRender
          >
            <Form form={createCompaniesFrom} labelCol={{ span: 5 }} wrapperCol={{span: 16}}>
              <div style={{flex: 1}}>
                <Form.Item label='生产企业名称' name='create_company' rules={commonInputRule}>
                  <Input />
                </Form.Item>
                <Form.Item label='住所' name='residence' rules={commonInputRule}>
                  <Input />
                </Form.Item>
                <Form.Item label='电话' name='vender_tel' rules={[...commonInputRule, {pattern:/^[^\u4e00-\u9fa5]*$/, message: '请输入正确的电话'}]}>
                  <Input min={0} style={{width: '100%'}} precision={0} />
                </Form.Item>
                <Form.Item label='生产地址' name='vender_address' rules={commonInputRule}>
                  <Input />
                </Form.Item>
              </div>
            </Form>
          </Modal>
        </div>
      </div>
    </div>
  )
}
export default BasicInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/basic-information.js